import Web3 from 'web3';
import { SiweMessage } from 'siwe';
import React, { Component } from "react";
import WalletConnect from "walletconnect";
import { Col, Button } from "reactstrap";
import NotificationSystem from "react-notification-system";
import PageSpinner from "../components/PageSpinner";

import "../styles/login.css";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";

import * as Server from "../Server";
import * as GeneralFunctions from "../GeneralFunctions";

const wc = new WalletConnect();

class WalletLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
    };
  }

  authenticate = async (walletConnect) => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "web3Auth/getSignMessage",
        method: "GET"
      });
      const message = response.messageToSign;
      if (!message) {
        throw new Error("Invalid message to sign");
      }
      let details = navigator.userAgent;
      let regexp = /android|iphone|kindle|ipad/i;
      let isMobileDevice = regexp.test(details);
      let signature;
      if (isMobileDevice || walletConnect) {
        const connector = await wc.connect();
        const account = connector.accounts.length ? connector.accounts[0] : null;
        if (account) {
          const siwe = new SiweMessage({
            domain: window.location.hostname,
            uri: window.location.origin,
            address: account,
            chainId: connector.chainId,
            version: '1',
            statement: message,
            nonce: await GeneralFunctions.getUid(16, 'alphaNumeric'),
          });
          const messageToSign = siwe.prepareMessage();
          await new Promise((resolve, reject) => {
            setTimeout(async () => {
              signature = await connector.signPersonalMessage([account, messageToSign]);
              clearTimeout();
              resolve();
            }, 5000);
          })
        }
      } else {
        const accounts = await window.ethereum.request({
          method: "eth_requestAccounts",
        });
        const web3 = new Web3(Web3.givenProvider);
        const account = Web3.utils.toChecksumAddress(accounts[0]);
        const siwe = new SiweMessage({
          domain: window.location.hostname,
          uri: window.location.origin,
          address: account,
          chainId: await web3.eth.getChainId(),
          version: '1',
          statement: message,
          nonce: await GeneralFunctions.getUid(16, 'alphaNumeric'),
        });
        const messageToSign = siwe.prepareMessage()
        signature = await web3.eth.personal.sign(messageToSign, account);
        let signatureVerified = await Server.request({
          url: 'web3Auth/verifySignMessage',
          method: "POST",
          data: {
            messageToSign,
            signature
          }
        });
        if (signatureVerified.success) {
          this.setState({ showLoader: false });
          GeneralFunctions.setAuthUser(signatureVerified.user);
          GeneralFunctions.setPermissions(signatureVerified.user.role);
          GeneralFunctions.setAuthorizationHeader(signatureVerified.token);
          localStorage.setItem("loggedInUsingWallet", true);
          localStorage.setItem("walletAddress", signatureVerified.walletAddress);
          this.props.history.push("/memberships");
          window.location.reload();
        } else {
          throw Error(signatureVerified.message);
        }
      }
    } catch (error) {
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
      this.setState({ showLoader: false });
    }
  }

  render() {
    return (
      <>
        <PageSpinner showLoader={this.state.showLoader} />
        <Col className="d-flex justify-content-center">
          <Button className="mr-2" color="primary" onClick={() => this.authenticate(false)}>
            Login with wallet
          </Button>
          <Button color="primary" onClick={() => this.authenticate(true)}>
            Login with WalletConnect
          </Button>
        </Col>
        <NotificationSystem
          dismissible={false}
          ref={(notificationSystem) =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />
      </>
    );
  }
}

export default WalletLogin;
